(function() {
    angular
        .module("app")
        .controller("WzChangeCustomerModalController", WzChangeCustomerModalController)

    WzChangeCustomerModalController.$inject = [
        "$scope",
        "$uibModalInstance",
        "performChange"
    ]

    function WzChangeCustomerModalController(
        $scope,
        $uibModalInstance,
        performChange
    ){
        "use strict"

        $scope.cancel = function() {
            $uibModalInstance.dismiss("cancel")
        }

        $scope.change = () => {
            $uibModalInstance.close(performChange())
        }
    }
})()
